import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
// The base stylesheet — palette, layout, and every shared component — with
// web.css layering the browser-only pieces on top.
import './styles.css'
import './web.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
